import { defineMessages } from 'react-intl';

/**
 * Single Messages is where we define any single word.
 * Words like "Submit", "Cancel", and "Company" to reduce
 * duplicated messages.
 *
 * The key should be the lowercase word.
 * The defaultMessage should be the word as Sentence case (cap the first letter)
 *
 * messages should be alphabetized by key
 */

export const singleMessages = defineMessages({
  email: { defaultMessage: 'Email' },
  password: { defaultMessage: 'Password' },
  cancel: { defaultMessage: 'Cancel' },
  company: { defaultMessage: 'Company' },
  submit: { defaultMessage: 'Submit' },
  unknown: { defaultMessage: 'Unknown' },
  status: { defaultMessage: 'Status' },
  open: { defaultMessage: 'Open' },
  closed: { defaultMessage: 'Closed' },
});

export const genericMessages = defineMessages({
  fieldRequired: {
    description: 'form validation error message',
    defaultMessage: 'This field is required',
  },
  noRecords: {
    defaultMessage: 'No Records',
  },
});
